import { BreakTime, validateBreakTime } from 'apis/types';
import { LabeledReadOnlyInput, ReadOnlyInput } from 'components/Fields';

interface BreakTimeProps {
  startTime?: string[];
  endTime?: string[];
  breakTimeTypeLabel: string;
}

interface BreakTimesProps {
  breakTimes: BreakTimeProps[];
  isMobile?: boolean;
}

interface BreakTimeForFirstChildProps extends BreakTimeProps {
  isMobile?: boolean;
}

export default function BreakTimes(breakTime: BreakTime, isMobile: boolean) {
  switch (breakTime.breakTimeType) {
    case 'DAILY':
      return (
        <BreakTimeForFirstChild
          startTime={breakTime.mondayStartTime}
          endTime={breakTime.mondayEndTime}
          breakTimeTypeLabel="매일"
          isMobile={isMobile}
        />
      );
    case 'WEEKDAY_WEEKEND':
      return BreakTimeList({
        breakTimes: [
          {
            startTime: breakTime.mondayStartTime,
            endTime: breakTime.mondayEndTime,
            breakTimeTypeLabel: '주중',
          },
          {
            startTime: breakTime.sundayStartTime,
            endTime: breakTime.sundayEndTime,
            breakTimeTypeLabel: '주말',
          },
        ],
        isMobile: isMobile,
      });
    default:
      return BreakTimeList({
        breakTimes: [
          {
            startTime: breakTime.mondayStartTime,
            endTime: breakTime.mondayEndTime,
            breakTimeTypeLabel: '월요일',
          },
          {
            startTime: breakTime.tuesdayStartTime,
            endTime: breakTime.tuesdayEndTime,
            breakTimeTypeLabel: '화요일',
          },
          {
            startTime: breakTime.wednesdayStartTime,
            endTime: breakTime.wednesdayEndTime,
            breakTimeTypeLabel: '수요일',
          },
          {
            startTime: breakTime.thursdayStartTime,
            endTime: breakTime.thursdayEndTime,
            breakTimeTypeLabel: '목요일',
          },
          {
            startTime: breakTime.fridayStartTime,
            endTime: breakTime.fridayEndTime,
            breakTimeTypeLabel: '금요일',
          },
          {
            startTime: breakTime.saturdayStartTime,
            endTime: breakTime.saturdayEndTime,
            breakTimeTypeLabel: '토요일',
          },
          {
            startTime: breakTime.sundayStartTime,
            endTime: breakTime.sundayEndTime,
            breakTimeTypeLabel: '일요일',
          },
        ],
        isMobile: isMobile,
      });
  }
}

const BreakTimeList = ({ breakTimes, isMobile = false }: BreakTimesProps) => {
  return breakTimes
    .filter(({ startTime, endTime }) => validateBreakTime(startTime, endTime))
    .map((item, i) => {
      if (i === 0) {
        return (
          <BreakTimeForFirstChild
            key={i}
            startTime={item.startTime}
            endTime={item.endTime}
            breakTimeTypeLabel={item.breakTimeTypeLabel}
            isMobile={isMobile}
          />
        );
      }

      return (
        <BreakTimeConponent
          key={i}
          startTime={item.startTime}
          endTime={item.endTime}
          breakTimeTypeLabel={item.breakTimeTypeLabel}
        />
      );
    });
};

const BreakTimeForFirstChild = ({
  startTime,
  endTime,
  breakTimeTypeLabel,
  isMobile,
}: BreakTimeForFirstChildProps) => {
  if (!validateBreakTime(startTime, endTime)) return null;

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <LabeledReadOnlyInput
        label="휴게시간"
        value={breakTimeTypeLabel}
        isMobile={isMobile}
        isColumn={true}
        style={{ width: 100 }}
      />
      <LabeledReadOnlyInput
        label="시작시간"
        value={startTime ? `${startTime[0]}시` : '-'}
        isMobile={isMobile}
        isColumn={true}
        style={{ width: `calc((100% - 100px - 8px * 4) / 4)`, minWidth: 60 }}
      />
      <ReadOnlyInput
        text={startTime ? `${startTime[1]}분` : '-'}
        style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 4) / 4)`, minWidth: 60 }}
      />
      <LabeledReadOnlyInput
        label="종료시간"
        value={endTime ? `${endTime[0]}시` : '-'}
        isMobile={isMobile}
        isColumn={true}
        style={{ width: `calc((100% - 100px - 8px * 4) / 4)`, minWidth: 60 }}
      />
      <ReadOnlyInput
        text={endTime ? `${endTime[1]}분` : '-'}
        style={{ marginTop: 'auto', width: `calc((100% - 100px - 8px * 4) / 4)`, minWidth: 60 }}
      />
    </div>
  );
};

const BreakTimeConponent = ({ startTime, endTime, breakTimeTypeLabel }: BreakTimeProps) => {
  if (!validateBreakTime(startTime, endTime)) return null;

  return (
    <div style={{ display: 'flex', gap: '8px', marginTop: 4 }}>
      <ReadOnlyInput text={breakTimeTypeLabel} style={{ width: 100 }} />
      <ReadOnlyInput
        text={startTime ? `${startTime[0]}시` : '-'}
        style={{ flex: 1, minWidth: 60 }}
      />
      <ReadOnlyInput
        text={startTime ? `${startTime[1]}분` : '-'}
        style={{ flex: 1, minWidth: 60 }}
      />
      <ReadOnlyInput text={endTime ? `${endTime[0]}시` : '-'} style={{ flex: 1, minWidth: 60 }} />
      <ReadOnlyInput text={endTime ? `${endTime[1]}분` : '-'} style={{ flex: 1, minWidth: 60 }} />
    </div>
  );
};
